import { axiosInstance } from '@/modules/Core/plugins/axios'
import { HR_AUTH_REFRESH_TOKEN } from '@/modules/Auth/requests/authEndpoints'
import type { AuthRefreshSuccessResponse } from '@/modules/Auth/types/api'

export const REFRESH_TOKEN_ENDPOINT = HR_AUTH_REFRESH_TOKEN

export async function refreshMutation(payload: { refreshToken: string }) {
  return axiosInstance.post<AuthRefreshSuccessResponse>(
    REFRESH_TOKEN_ENDPOINT,
    payload,
    { skipErrorToast: true }
  )
}
